(function () {
  const attributionKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'gbraid',
    'wbraid',
    'msclkid',
    'fbclid',
  ];
  const storagePrefix = 'equippedmd_attribution_';
  const submissionStoragePrefix = 'equippedmd_lead_';
  const jotformHosts = ['jotform.com', 'jotform.pro', 'jotfor.ms'];

  function safeStorageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeStorageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      // Storage can be disabled; tracking should never interrupt the form.
    }
  }

  function captureAttribution() {
    const searchParams = new URLSearchParams(window.location.search);

    attributionKeys.forEach(function (key) {
      const value = searchParams.get(key);

      if (value) {
        safeStorageSet(window.sessionStorage, storagePrefix + key, value);
      }
    });
  }

  function enrichJotformUrl(url) {
    let enrichedUrl;

    try {
      enrichedUrl = new URL(url, window.location.origin);
    } catch (error) {
      return url;
    }

    attributionKeys.forEach(function (key) {
      const value = safeStorageGet(window.sessionStorage, storagePrefix + key);

      if (value && !enrichedUrl.searchParams.has(key)) {
        enrichedUrl.searchParams.set(key, value);
      }
    });

    // The theme now renders landing_url server-side, so the first iframe load
    // already carries it. Only fill it in when it is genuinely absent, so that
    // enrichment can return the URL unchanged and the caller can skip a
    // needless second load of the form.
    if (!enrichedUrl.searchParams.has('landing_url')) {
      enrichedUrl.searchParams.set('landing_url', window.location.origin + window.location.pathname);
    }

    return enrichedUrl.toString();
  }

  function isAllowedJotformOrigin(origin) {
    try {
      const originUrl = new URL(origin);
      const hostname = originUrl.hostname.toLowerCase();

      return originUrl.protocol === 'https:' && jotformHosts.some(function (allowedHost) {
        return hostname === allowedHost || hostname.endsWith('.' + allowedHost);
      });
    } catch (error) {
      return false;
    }
  }

  function parseMessage(data) {
    if (data && typeof data === 'object') {
      return data;
    }

    if (typeof data !== 'string') {
      return null;
    }

    try {
      const parsed = JSON.parse(data);

      if (parsed && typeof parsed === 'object') {
        return parsed;
      }
    } catch (error) {
      // Some Jotform messages use a colon-delimited string.
    }

    if (data.indexOf('submission-completed') === 0) {
      const parts = data.split(':');
      return {
        action: parts[0],
        submissionID: parts[1],
        formID: parts[2],
      };
    }

    return null;
  }

  function iframeForSource(source) {
    return Array.from(document.querySelectorAll('iframe')).find(function (iframe) {
      return iframe.contentWindow === source;
    });
  }

  function formIdFromIframe(iframe) {
    if (!iframe) return '';

    const formIdMatch = (iframe.src || iframe.dataset.jotformBaseUrl || '').match(/\/(?:form\/)?(\d{10,})/);
    return formIdMatch ? formIdMatch[1] : '';
  }

  function leadTypeForForm(formId) {
    if (formId === '250995872329068') return 'inquiry';
    if (formId === '261456674900057') return 'contact';
    return 'form_submission';
  }

  function trackSuccessfulSubmission(event) {
    if (!isAllowedJotformOrigin(event.origin)) return;

    const message = parseMessage(event.data);

    if (!message || message.action !== 'submission-completed') return;

    const iframe = iframeForSource(event.source);
    const formId = String(message.formID || message.formId || formIdFromIframe(iframe));
    const submissionId = String(
      message.submissionID || message.submissionId || message.submission_id || message.submission || ''
    );

    // The Jotform submission ID is the analytics/CRM de-duplication key. Do not
    // manufacture a client-side replacement when Jotform doesn't send it.
    if (!formId || !submissionId) return;

    const dedupeKey = submissionStoragePrefix + submissionId;

    if (safeStorageGet(window.localStorage, dedupeKey)) return;
    safeStorageSet(window.localStorage, dedupeKey, '1');

    const body = document.body;
    const eventPayload = {
      event: 'generate_lead',
      form_id: formId,
      lead_type: leadTypeForForm(formId),
      originating_page_type: body.dataset.pageType || '',
      product_handle: body.dataset.productHandle || '',
      collection_handle: body.dataset.collectionHandle || '',
      landing_url: window.location.origin + window.location.pathname,
      submission_id: submissionId,
      event_id: submissionId,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventPayload);
    document.dispatchEvent(new CustomEvent('equippedmd:generate_lead', { detail: eventPayload }));
  }

  captureAttribution();
  window.EquippedMDLeadTracking = {
    enrichJotformUrl: enrichJotformUrl,
  };
  window.addEventListener('message', trackSuccessfulSubmission);
})();
